import { baseTemplateParams } from '../shared/baseParams.js'
import { SAMPLE_CAMPAIGN_RICHTEXT_FIELDS } from '../shared/sampleCampaignContent.js'

export const defaultTemplateParams = {
  ...baseTemplateParams,
  headerBgColor: 'transparent',
  logoUrl: '',
  heroImgUrl: '',
  heroImageLinkUrl: '',
  preheaderText: 'This text will appear next to your subject line in the inbox.',
  subject: 'This is the email subject',
  ctaTextColor: '#ffffff',
  col1Image: '',
  col1ImageLinkUrl: '',
  col2Image: '',
  col2ImageLinkUrl: '',
  richtextFields: {
    ...SAMPLE_CAMPAIGN_RICHTEXT_FIELDS
  },
  selectedTemplate: 'twoColumn',
  shellTemplateKey: 'twoColumn'
}

export default defaultTemplateParams
